var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible && _vm.janelaId)?_c('div',[_c('portal',{attrs:{"to":_vm.janelaId}},[_vm._t("default",null,{"hdl":_vm.hdl})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }